import React, { useEffect, useRef, useState } from 'react';

const Partners: React.FC = () => {
  const clientLogos = [
    "/client-logos/zoonewengland.svg",
    "/client-logos/naplesbotanicalgarden.png",
    "/client-logos/zootampa.png",
    "/client-logos/ncaquariums.png",
    "/client-logos/jacksonvillezoo.png",
    "/client-logos/armyaviationmuseumfoundation.jpg",
    "/client-logos/cityofraleigh.png",
    "/client-logos/brevardazoo.png",
    "/client-logos/medalofhonormuseum.png",
    "/client-logos/magnoliaplantationgardens.jpg",
    "/client-logos/patriotspoint.png",
    "/client-logos/sylvanheightsbirdpark.png",
    "/client-logos/arnoldspark.png"
  ];

  return (
    <div className="overflow-hidden whitespace-nowrap relative w-full bg-white flex items-center">
      <div className="flex animate-marquee space-x-8 p-[4.4rem]">
        {[...clientLogos, ...clientLogos, ...clientLogos, ...clientLogos, ...clientLogos].map((logo, index) => (
          <img
            key={index}
            src={logo}
            alt="Client Logo"
            className="h-auto max-h-[9rem] mx-4"
          />
        ))}
      </div>
    </div>
  );
};

export default Partners;
